/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qc_Fix_All_DescriptionInputs */



/**
* | output |
* | --- |
* | "Tick the issues you want to fix across the entire event group." |
*
* @param {Qc_Fix_All_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const qc_fix_all_description = /** @type {((inputs?: Qc_Fix_All_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qc_Fix_All_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cochez les problèmes à corriger dans tout le groupe d'événements.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie die Probleme aus, die in der gesamten Event-Gruppe korrigiert werden sollen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona i problemi da correggere nell'intero gruppo di eventi.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отметьте проблемы, которые нужно исправить во всей группе событий.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Marque los problemas que desea corregir en todo el grupo de eventos.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("勾选要在整个事件组中修复的问题。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントグループ全体で修正したい問題にチェックを入れてください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पूरे इवेंट समूह में जिन समस्याओं को ठीक करना है उन्हें चुनें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Assinale os problemas que pretende corrigir em todo o grupo de eventos.")
	return /** @type {LocalizedString} */ ("Tick the issues you want to fix across the entire event group.")
});